export default "__VITE_ASSET__BhyOJ3UB__"